
export enum Mode {
    NORMAL, EDIT, ADD, DELETE, SUCCESS
}
